export default [
	{
		path: "bookings/",
		component: () =>
			import(
				/* webpackChunkName: "bookingssuperview"*/ "@/views/Bookings/index.vue"
			),
		children: [
			{
				path: "site-tours",
				name: "BookingsSuperSiteTourView",
				component: () =>
					import(
						/* webpackChunkName: "bookingssupersitetourview"*/ "@/views/Bookings/SiteTours/index.vue"
					),
				meta: {
					title: "DailyAdmin - Site tours"
				}
			},
			{
				path: "callouts",
				name: "BookingsSuperCalloutView",
				component: () =>
					import(
						/* webpackChunkName: "bookingssupercalloutview"*/ "@/views/Bookings/Callouts/index.vue"
					),
				meta: {
					title: "DailyAdmin - Callouts"
				}
			}
		]
	},
	{
		path: "bookings/site-tours/:requestid/:bookingid/view",
		name: "BookingSuperSiteTourView",
		component: () =>
			import(
				/* webpackChunkName: "bookingsupersitetourview"*/ "@/views/Bookings/SiteTours/View.vue"
			),
		meta: {
			title: "DailyAdmin - Site tour view"
		}
	},
	{
		path: "bookings/site-tours/:requestid/:bookingid/cancel/:type",
		name: "BookingSuperSiteTourCancel",
		component: () =>
			import(
				/* webpackChunkName: "bookingsupersitetourcancel"*/ "@/views/Bookings/RequestCancel.vue"
			),
		meta: {
			title: "DailyAdmin - Site tour view"
		}
	},
	{
		path: "bookings/callouts/:requestid/:bookingid/view",
		name: "BookingSuperCalloutView",
		component: () =>
			import(
				/* webpackChunkName: "bookingsupercalloutview"*/ "@/views/Bookings/Callouts/View.vue"
			),
		meta: {
			title: "DailyAdmin - Callout view"
		}
	},
	{
		path: "bookings/callouts/:requestid/:bookingid/cancel/:type",
		name: "BookingSuperCalloutCancel",
		component: () =>
			import(
				/* webpackChunkName: "bookingsupersitetourcancel"*/ "@/views/Bookings/RequestCancel.vue"
			),
		meta: {
			title: "DailyAdmin - Site tour view"
		}
	}
];
